(() => {
  'use strict';
  const storageKey = 'pxm-boutique-17.8.1';
  const readReturn = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey));
      if (!saved || Date.now() - saved.time > 7200000) return null;
      const url = new URL(saved.url, location.origin);
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:pages\/nos-plantes|collections\/[^/]+)$/.test(url.pathname)) return null;
      return saved;
    } catch { return null; }
  };
  const saveReturn = (value) => {
    try { sessionStorage.setItem(storageKey, JSON.stringify(value)); } catch { /* Navigation works without storage. */ }
  };
  function init() {
    const back = document.querySelector('[data-catalog-back]');
    if (back && !back.dataset.initialized) {
      back.dataset.initialized = 'true';
      const saved = readReturn();
      if (saved && saved.product === location.pathname) {
        back.href = saved.url;
        back.addEventListener('click', () => saveReturn({ ...saved, restore: true, time: Date.now() }));
      }
    }
    document.querySelectorAll('[data-pxm-catalog]').forEach(initCatalog);
  }
  function initCatalog(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const grid = root.querySelector('[data-product-grid]');
    const cards = [...grid.querySelectorAll('[data-product]')];
    const tabs = [...root.querySelectorAll('[data-category]')];
    const groups = [...root.querySelectorAll('[data-accessory]')];
    const form = root.querySelector('form');
    const pricePanel = root.querySelector('[data-price-panel]');
    const activeFilters = root.querySelector('[data-active-filters]');
    const defaults = { stock: 'all', min: '', max: '', sort: 'selection' };
    const names = Object.keys(defaults);
    let category = root.dataset.initialCategory;
    let accessory = 'all';
    const field = (name) => form.elements.namedItem(name);
    const valueOf = (name) => name === 'stock' ? (field(name).checked ? 'available' : 'all') : field(name).value;
    const setValue = (name, value) => {
      if (name === 'stock') field(name).checked = value === 'available';
      else field(name).value = value;
    };
    form.hidden = false;
    groups.forEach((button) => {
      const count = cards.filter((card) => card.dataset.categories.split(' ').includes('accessoires') && (button.dataset.accessory === 'all' || card.dataset.accessoryGroup === button.dataset.accessory)).length;
      button.querySelector('[data-group-count]').textContent = count;
      button.hidden = count === 0 && button.dataset.accessory !== 'all';
    });

    function readURL() {
      const params = new URL(location.href).searchParams;
      category = tabs.some((tab) => tab.dataset.category === params.get('categorie')) ? params.get('categorie') : root.dataset.initialCategory;
      accessory = category === 'accessoires' && groups.some((group) => group.dataset.accessory === params.get('accessoire')) ? params.get('accessoire') : 'all';
      names.forEach((name) => {
        setValue(name, params.get(name) ?? defaults[name]);
        if (field(name).tagName === 'SELECT' && !valueOf(name)) setValue(name, defaults[name]);
        if (field(name).type === 'number' && (!Number.isFinite(Number(valueOf(name))) || Number(valueOf(name)) < 0)) setValue(name, '');
      });
      if (!params.has('stock') && params.get('filter.v.availability') === '1') setValue('stock', 'available');
    }
    function writeURL(replace = false) {
      const url = new URL(location.href);
      for (const key of [...url.searchParams.keys()]) {
        if (key.startsWith('filter.') || key === 'sort_by' || key === 'delivery') url.searchParams.delete(key);
      }
      url.searchParams.set('categorie', category);
      if (category === 'accessoires' && accessory !== 'all') url.searchParams.set('accessoire', accessory);
      else url.searchParams.delete('accessoire');
      names.forEach((name) => {
        const value = valueOf(name);
        if (value === defaults[name]) url.searchParams.delete(name);
        else url.searchParams.set(name, value);
      });
      if (url.href !== location.href) history[replace ? 'replaceState' : 'pushState']({}, '', url);
    }
    function render(updateHistory = false) {
      const values = Object.fromEntries(names.map((name) => [name, valueOf(name)]));
      const min = values.min === '' ? 0 : Number(values.min) * 100;
      const max = values.max === '' ? Infinity : Number(values.max) * 100;
      const invalidBudget = max < min;
      root.querySelector('[data-budget-error]').hidden = !invalidBudget;
      field('max').setCustomValidity(invalidBudget ? 'Le maximum doit être supérieur ou égal au minimum.' : '');
      const ordered = [...cards];
      ordered.sort((a, b) => {
        if (values.sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (values.sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (values.sort === 'newest') return Number(b.dataset.created) - Number(a.dataset.created);
        return Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true');
      });
      let count = 0;
      ordered.forEach((card) => {
        const data = card.dataset;
        const visible = data.categories.split(' ').includes(category)
          && (category !== 'accessoires' || accessory === 'all' || accessory === data.accessoryGroup)
          && (values.stock === 'all' || data.available === 'true')
          && Number(data.price) >= min && Number(data.price) <= max;
        card.hidden = !visible;
        if (visible) count++;
        grid.append(card);
      });
      tabs.forEach((tab) => {
        if (tab.dataset.category === category) tab.setAttribute('aria-current', 'true');
        else tab.removeAttribute('aria-current');
      });
      groups.forEach((group) => group.setAttribute('aria-pressed', String(group.dataset.accessory === accessory)));
      root.querySelector('[data-accessory-groups]').hidden = category !== 'accessoires';
      const label = tabs.find((tab) => tab.dataset.category === category)?.dataset.label || 'La sélection';
      root.querySelector('[data-result-count]').textContent = `${count} produit${count === 1 ? '' : 's'} · ${label}`;
      root.querySelector('[data-empty]').hidden = count > 0;
      const hasBudget = values.min !== '' || values.max !== '';
      root.querySelector('[data-price-active]').hidden = !hasBudget;
      activeFilters.replaceChildren();
      const addChip = (key, text) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.removeFilter = key;
        button.textContent = `${text} ×`;
        button.setAttribute('aria-label', `Retirer le filtre : ${text}`);
        activeFilters.append(button);
      };
      if (values.stock === 'available') addChip('stock', 'En stock');
      if (hasBudget) {
        const euro = (value) => `${Number(value).toLocaleString('fr-FR')} €`;
        const budgetLabel = values.min !== '' && values.max !== '' ? `${euro(values.min)} à ${euro(values.max)}` : values.max !== '' ? `Jusqu’à ${euro(values.max)}` : `Dès ${euro(values.min)}`;
        addChip('budget', budgetLabel);
      }
      activeFilters.hidden = activeFilters.children.length === 0;
      root.querySelector('.pxm-catalog__results [data-reset]').hidden = !hasBudget && values.stock === 'all' && values.sort === defaults.sort && accessory === 'all';
      if (updateHistory) writeURL();
    }
    tabs.forEach((tab) => tab.addEventListener('click', (event) => {
      if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      // A plant budget must not silently hide a different accessories range.
      if ((category === 'accessoires') !== (tab.dataset.category === 'accessoires')) {
        setValue('min', '');
        setValue('max', '');
      }
      category = tab.dataset.category;
      accessory = 'all';
      pricePanel.open = false;
      render(true);
    }));
    groups.forEach((group) => group.addEventListener('click', () => {
      accessory = group.dataset.accessory;
      render(true);
    }));
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      render(true);
      if (!form.reportValidity()) return;
      pricePanel.open = false;
      pricePanel.querySelector('summary').focus();
    });
    form.addEventListener('change', () => render(true));
    form.addEventListener('input', () => { field('max').setCustomValidity(''); });
    pricePanel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        pricePanel.open = false;
        pricePanel.querySelector('summary').focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (!pricePanel.contains(event.target)) pricePanel.open = false;
    });
    activeFilters.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-remove-filter]');
      if (!chip) return;
      if (chip.dataset.removeFilter === 'budget') { setValue('min', ''); setValue('max', ''); }
      else setValue('stock', 'all');
      render(true);
      field('stock').focus();
    });
    root.querySelectorAll('[data-reset]').forEach((button) => button.addEventListener('click', () => {
      names.forEach((name) => setValue(name, defaults[name]));
      accessory = 'all';
      render(true);
      field('stock').focus();
    }));
    grid.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      saveReturn({ url: location.href, product: new URL(link.href).pathname, scroll: window.scrollY, time: Date.now(), restore: false });
    });
    // The existing mobile Boutique shortcut returns to the controls without resetting filters.
    document.querySelectorAll('.pxm-mobile-primary__link[aria-current="page"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        tabs.find((item) => item.dataset.category === category)?.focus({ preventScroll: true });
        root.querySelector('[data-category]').closest('nav').scrollIntoView({ block: 'start', behavior: 'instant' });
      });
    });
    window.addEventListener('popstate', () => { readURL(); render(); });
    function restorePosition() {
      const saved = readReturn();
      const backNavigation = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
      if (saved && saved.url === location.href && (saved.restore || backNavigation)) {
        requestAnimationFrame(() => window.scrollTo(0, Math.max(0, Number(saved.scroll) || 0)));
        saveReturn({ ...saved, restore: false });
      }
    }
    window.addEventListener('pageshow', restorePosition);
    readURL();
    render();
    if (new URL(location.href).searchParams.has('delivery')) writeURL(true);
    restorePosition();
    function revealOffer() {
      if (location.hash === '#offre-bienvenue') {
        const offer = root.querySelector('#offre-bienvenue');
        offer.open = true;
        offer.scrollIntoView();
      }
    }
    revealOffer();
    window.addEventListener('hashchange', revealOffer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
